export function composerPresentationSendBusy(input: {
  readonly localDispatchBusy: boolean;
  readonly pendingAutoSubmit: boolean;
}): boolean {
  return input.localDispatchBusy || input.pendingAutoSubmit;
}
